const assignor = {
  id: 0,
  vortx_assignor_integration_documents_status: 'not_sended',
  status: '',
  assignor_type: '',
  cnpj: '',
  fantasy_name: '',
  legal_name: '',
  uf: '',
  city: '',
  cep: '',
  neighborhood: '',
  address: '',
  address_number: '',
  email_nfse: '',
  contact_name: '',
  contact_phone: '',
  contact_cellphone: '',
  contact_email: '',
  website: '',
  min_days: '',
  max_days: '',
  min_value: '',
  internal_tax: '',
  internal_commission: '',
  new_limit: '',
  eligible: false,
  payer_ids: [],
  last_limits: [],
  limits_attributes: [],
  bank_accounts: [],
  bank_accounts_attributes: [],
  assignor_representatives: [],
  assignor_representatives_attributes: [],
  branch_offices: [],
  branch_offices_attributes: [],
  assignor_funds: [],
  assignor_funds_attributes: [],
  contacts: [],
  contacts_attributes: [],
  assignor_documentations: []
}

const errors = {
  infos: [],
  importRule: [],
  taxLimit: [],
  bankAccount: [],
  representative: [],
  docs: [],
  branch_offices: [],
  assignor: {},
  funds: [],
  import_assignors: [],
  contacts: []
}

export default {
  initalAssignor: { ...assignor },
  assignor: { ...assignor },
  initialErrors: { ...errors },
  errors: { ...errors },
  list: [],
  current: {},
  contractTemplateOptions: []
}



// WEBPACK FOOTER //
// ./src/features/assignors/store/state.js